import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_LATENTS__create_noise } from '../../../_invocations/latents/INVOCATION_LATENTS__create_noise';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__text_encoder } from '../../../_invocations/sd/guidance/INVOCATION_SD__text_encoder';
import { INVOCATION_SD__latents_to_image } from '../../../_invocations/sd/vae/INVOCATION_SD__latents_to_image';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__grid2d_view__tune_text(tool: DTO__generation_tool) {
  /*
   *
   */

  /*
   *
   */
  let graph = DTO_GRAPH__instance.CREATE_NEW();
  tool.graph = graph;

  /*
   *
   */
  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   * LATENTS TO IMAGE
   */
  const node__latents_to_image = INVOCATION_SD__latents_to_image.create_node_for(graph, ENUM.CORE__LATENTS_TO_IMAGE);

  //todo: mb need check is enabled/disabled edge used
  // if (!graph.node__is_connected_to_node_grid2d_view(node__latents_to_image)) {
  graph.edge__try_add_for_fields(node__latents_to_image.out, node__grid2d.image);
  // }

  /*
   * DENOISE
   */

  const node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  graph.edge__try_add_for_fields(node__denoise.out__latents, node__latents_to_image.latents);

  /*
   * NOISE
   */

  const node__noise = INVOCATION_LATENTS__create_noise.create_node_for(graph, ENUM.CORE__LATENTS_NOISE);

  graph.edge__try_add_for_fields(node__noise.out__latents, node__denoise.noise);
  graph.edge__try_add_for_fields(node__noise.seed, node__denoise.seed);

  /*
   * PROMPT GLOBAL
   */

  const node__text_encoder_global = INVOCATION_SD__text_encoder.create_node_for(graph, ENUM.CORE__TEXT_ENCODER);

  graph.edge__try_add_for_fields(node__text_encoder_global.out__positive, node__denoise.conditioning_global__positive);
  graph.edge__try_add_for_fields(node__text_encoder_global.out__negative, node__denoise.conditioning_global__negative);

  /*
   * PROMPT REGIONAL
   */
  // const node__text_encoder_regional = INVOCATION_SD__text_encoder_masked.create_field_container_default();
  // out.node__add(node__text_encoder_regional);

  // out.edge__try_add_for_fields(node__text_encoder_regional.out__positive, denoise.conditioning_regional__positive);
  // out.edge__try_add_for_fields(node__text_encoder_regional.out__negative, denoise.conditioning_regional__negative);

  /*
   * UI
   */

  node__text_encoder_global.tokens.meta.field_role = 'Prompt Tokens';

  let fields__visible: FIELD__base[] = [
    node__noise.seed,
    node__text_encoder_global.tokens,
    node__text_encoder_global.grid2d_mode__token_vs_token,
    node__text_encoder_global.grid2d_mode__token_after_token,
    node__text_encoder_global.grid2d_mode__single_token_generation,
    node__text_encoder_global.grid2d_mode__all_tokens_except_one,
  ];

  let field_column_id = node__noise.seed.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.TUNE_DESCRIPTION,
    group: '0. Base',

    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    //
    field_ids_info__items_amount: [node__text_encoder_global.tokens.meta.field_id],
  });

  /*
   *
   */

  //todo: use after implementting token_from..token_to
  // graph.grid2d__use_as_row(node__text_encoder_global.grid2d_mode__token_after_token.meta.field_id);
}
